import { render, staticRenderFns } from "./RiskJobForm.vue?vue&type=template&id=b78c5d10&scoped=true"
import script from "./RiskJobForm.vue?vue&type=script&lang=js"
export * from "./RiskJobForm.vue?vue&type=script&lang=js"
import style0 from "./RiskJobForm.vue?vue&type=style&index=0&id=b78c5d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78c5d10",
  null
  
)

export default component.exports